// Generated by CoffeeScript 2.3.2

import Menu from '@material-ui/core/Menu'
import MenuItem from '@material-ui/core/MenuItem'
import React, { Component } from 'react';
;
var MainMenu, version,
  boundMethodCheck = function(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new Error('Bound instance method accessed before binding'); } };

version = require('./version');

MainMenu = class MainMenu extends Component {
  constructor() {
    super(...arguments);
    this.handleStart = this.handleStart.bind(this);
    this.handleLog = this.handleLog.bind(this);
    this.handleExport = this.handleExport.bind(this);
    this.handleImport = this.handleImport.bind(this);
  }

  handleStart() {
    boundMethodCheck(this, MainMenu);
    this.props.app.showNewGameDialog();
    this.props.onClose();
  }

  handleLog() {
    boundMethodCheck(this, MainMenu);
    this.props.app.showLog();
    this.props.onClose();
  }

  handleExport() {
    boundMethodCheck(this, MainMenu);
    this.props.app.showExportDialog();
    this.props.onClose();
  }

  handleImport() {
    boundMethodCheck(this, MainMenu);
    this.props.app.showImportDialog();
    this.props.onClose();
  }

  render() {
    var anchor, onClose, started;
    ({anchor, started, onClose} = this.props);
    return <Menu id="main-menu" anchorEl={anchor} open={Boolean(anchor)} onClose={onClose}>
      <MenuItem onClick={this.handleStart}> Start New Game </MenuItem>
      <MenuItem onClick={this.handleImport}> Import Log </MenuItem>
      <MenuItem disabled={!started} onClick={this.handleLog}> Show Log </MenuItem>
      <MenuItem disabled={!started} onClick={this.handleExport}> Export Log </MenuItem>
      <MenuItem disabled={true}> {version} </MenuItem>
    </Menu>;
  }

};

export default MainMenu;
